/*******************************************************************************
 * Variation: With Reviews
 * wp-block-plaudit-experts-team-grid
 */
// No JS needed for this variation

/*******************************************************************************
 * Variation: Animated
 * wp-block-plaudit-image-grid
 */
function getRandomInt(max: number) {
	return Math.round(Math.random() * max);
}

const imageTransitionSpeed = 3000; // Matches the css
const imageSwapInterval = 3000;  // Transition an image every X seconds

const imageGrids = document.querySelectorAll('.wp-block-plaudit-image-grid__gridWrapper');
imageGrids.forEach(imageGrid => {
	const forSwappingIn = imageGrid.querySelectorAll<HTMLElement>('li.wp-block-plaudit-image-grid__item--forSwapping');
	if (forSwappingIn.length == 0) {
		return;
	}

	const visibleItems = imageGrid.querySelectorAll<HTMLElement>('li:not(.wp-block-plaudit-image-grid__item--forSwapping)');

	const swap = () => {
		const spotTo = visibleItems[getRandomInt(visibleItems.length - 1)];
		const curImg = spotTo.querySelector('img');
		const spotFrom = forSwappingIn[getRandomInt(forSwappingIn.length - 1)];
		const newImg = spotFrom.querySelector('img');

		// Fade current image out
		curImg?.classList.toggle('wp-block-plaudit-image-grid__image--hide', true);

		// Fade current in
		if (newImg) {
			newImg.classList.add('wp-block-plaudit-image-grid__image--under');
			newImg.classList.add('wp-block-plaudit-image-grid__image--hide');
			spotTo.appendChild(newImg);
			setTimeout(() => {
				newImg.classList.remove('wp-block-plaudit-image-grid__image--hide');
			}, imageTransitionSpeed / 3);
		}

		setTimeout(() => {
			if (curImg) {
				// Fade in - CSS transition
				curImg.classList.remove('wp-block-plaudit-image-grid__image--hide');

				// Move previous image to the not visible spots
				spotFrom.appendChild(curImg);
			}

			// New image should no longer be under
			newImg?.classList.remove('wp-block-plaudit-image-grid__image--under');

			startSwapInterval();
		}, imageTransitionSpeed);
	}
	const startSwapInterval = () => {
		setTimeout(swap, imageSwapInterval);
	};

	startSwapInterval();
});
